import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { urls } from "../configs/serviceConfig";
import { authorizationHeaders } from "./authorizationHeaders";
import { ProgrammeOverview } from "../types/ProgrammeOverview";

export enum RoutingSlipStatus {
  InProgress = "InProgress",
  Completed = "Completed",
  Faulted = "Faulted",
}

type RoutingSlipTracker = {
  status: RoutingSlipStatus;
};

type CompleteStepCombined = {
  profileId: string;
  journeyId: string;
  programmeId: string;
  stepId: string;
  partId: string;
  step0Complete: boolean;
};

type GetRsTracker = {
  profileId: string;
  trackingNumber: string;
};

interface GetUserProgrammeOverviewRequest {
  profileId: string;
  journeyId: string;
  programmeId: string;
}

export const programmeApi = createApi({
  reducerPath: "programmeApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${urls.programmeService}`,
    prepareHeaders: authorizationHeaders,
  }),

  endpoints: (builder) => ({
    getUserProgrammeOverview: builder.query<
      string,
      GetUserProgrammeOverviewRequest
    >({
      query: (data) => {
        return `/user-programme/${data.programmeId}/user/${data.profileId}/journey/${data.journeyId}/overview`;
      },
    }),
    getProgrammeOverview: builder.query<ProgrammeOverview, string>({
      query: (data) => {
        return `/programmes/overview/${data}`;
      },
    }),
    completePartCombined: builder.mutation<string, CompleteStepCombined>({
      query(data) {
        const {
          profileId,
          journeyId,
          programmeId,
          stepId,
          partId,
          step0Complete,
        } = data;
        return {
          url: `/user-programme/${programmeId}/user/${profileId}/journey/${journeyId}/combined-complete-part`,
          method: "POST",
          body: {
            stepId: stepId,
            partId: partId,
            step0Completed: step0Complete,
          },
        };
      },
    }),
    getRoutingSlipTracker: builder.query<RoutingSlipTracker, GetRsTracker>({
      query: (data) => {
        return `/user/${data.profileId}/routing-slip/${data.trackingNumber}`;
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useCompletePartCombinedMutation,
  useGetRoutingSlipTrackerQuery,
  useGetProgrammeOverviewQuery,
} = programmeApi;
